import Join from './Join';

export default Join;
